var isBrowser = typeof window !== 'undefined';
const $ = isBrowser ? window.$ : {};
var React = require( 'react' );
var createReactClass = require('create-react-class');
var Link = require('react-router').Link;
var LinkWrapper = require('./linkWrapper.jsx')(Link);

var Header = createReactClass({

    componentDidMount: function(){
        $('.menu-icon').click(function(){
            $('body').toggleClass('is-menu-open');
        });
    },

    handleClickTracking: function(e) {
        var currentTarget = e.currentTarget;
        var action = currentTarget.innerText;
        var label = currentTarget.href;
        this.props.clickTracking(action, label);
    },

    showInterestedInClinicalTrials: function(e){
        this.props.showModal('MODAL_TYPE_INTERESTED_IN_CLINICAL_TRIALS');
        this.props.recordClinicalTrialsClick('Click', e.currentTarget.innerText);
    },

	render: function(){
        var interestedInClinicalTrialsEntryNode = !this.props.isLogin
            ? <a className="highlight show-for-xlarge hide" onClick={this.showInterestedInClinicalTrials}>Interested in Clinical Trials?</a>
            : null;

        var userPaneNode = (
            <div className="user-pane">
                {interestedInClinicalTrialsEntryNode}
                <LinkWrapper className="primary" to="/register" handler={this.props.clickTracking}>Sign Up</LinkWrapper>
                <LinkWrapper to="/login" handler={this.props.clickTracking}>Login</LinkWrapper>
            </div>
        );

        var profileNode = null;

        if(this.props.isLogin) {
            profileNode = (
                <LinkWrapper to="/profile" action="Profile" handler={this.props.clickTracking}>
                    <span className="icon-user"></span>
                    {this.props.profile.firstName + ' ' + this.props.profile.lastName}
                    <span className="ion-ios-arrow-down show-for-large"></span>
                    <span className="tip hide-for-large">View Your Account</span>
                </LinkWrapper>
            );
            userPaneNode = (
                <div className="user-pane">
                    {interestedInClinicalTrialsEntryNode}
		    		{profileNode}
                    <p className="hide-for-large"><button className="button secondary expanded" type="button" onClick={this.props.onLogout}>Log Out</button></p>
                </div>
            );
        }

        var logoUrl = 'https://res.cloudinary.com/mytotalhealth/image/upload/q_auto/web/logo.png';
        if(this.props.isLogin){
            logoUrl = 'https://res.cloudinary.com/mytotalhealth/image/upload/q_auto/web/icon-mygi-platformlogo.png';
        }

		return (
		    <header id="header" className="hide">
	    	  <div className="title-bar clearfix">
                <div className="float-right">
                    {profileNode &&
                        <span className="user-pane">{profileNode}</span>
                    }
				    <button className="menu-icon" type="button"></button>
                </div>
                {interestedInClinicalTrialsEntryNode && (
                    <div className="show-for-medium float-right">
                        {interestedInClinicalTrialsEntryNode}
                    </div>
                )}
				<LinkWrapper className="float-left" to="/" id="logo" title="Back to home" action="Home Logo - Mobile" handler={this.props.clickTracking}><img src={logoUrl} alt="MyGiHealth" /></LinkWrapper>
			  </div>
			  <div className="top-bar">
					<LinkWrapper className="show-for-large" to="/" id="logo" title="Back to home" action="Home Logo" handler={this.props.clickTracking}><img src={logoUrl} alt="MyGiHealth" /></LinkWrapper>
                    <nav>
                        {!this.props.isLogin &&
                            <ul className="inline-list">
                                <li className="education hide"><LinkWrapper to="/education" handler={this.props.clickTracking}>Learning Center</LinkWrapper></li>
                                <li className="conditions hide"><LinkWrapper to="/conditions" handler={this.props.clickTracking}>Treatment Center</LinkWrapper></li>
                                <li className="find-a-specialist hide"><LinkWrapper to="/find-a-specialist" handler={this.props.clickTracking}>Find a Specialist</LinkWrapper></li>
                                <li className="blog hide-for-large hide"><LinkWrapper to="/blog" handler={this.props.clickTracking}>Blog</LinkWrapper></li>
                                <li className="about hide-for-large hide"><LinkWrapper to="/about" handler={this.props.clickTracking}>About Us</LinkWrapper></li>
                            </ul>
                        }
                        {this.props.isLogin &&
                            <ul className="is-logged-in inline-list">
                                <li className="mygi hide"><LinkWrapper to="/dashboard/mygi" handler={this.props.clickTracking}>MyGi</LinkWrapper></li>
                                <li className="quality-of-life hide"><LinkWrapper to="/dashboard/myqol" handler={this.props.clickTracking}>Quality of Life</LinkWrapper></li>
                                <li className="doctor-visit-prep hide"><LinkWrapper to="/dashboard/doctor-visit" handler={this.props.clickTracking}>Doctor Visit Prep</LinkWrapper></li>
                                <li className="find-a-specialist hide"><LinkWrapper to="/find-a-specialist" handler={this.props.clickTracking}>Find a Specialist</LinkWrapper></li>
                                <li className="split hide"></li>
                                <li className="education hide"><LinkWrapper to="/education" handler={this.props.clickTracking}>Learning Center</LinkWrapper></li>
                                <li className="conditions hide"><LinkWrapper to="/conditions" handler={this.props.clickTracking}>Treatment Center</LinkWrapper></li>
                                <li className="split hide-for-large hide"></li>
                            </ul>
                        }
		            </nav>
                    {userPaneNode}
                    <p className="hide-for-large">
                        <a className="download-app" href="http://get.mygihealth.io/downloadtheapp" onClick={this.handleClickTracking}>
                            <img src="https://res.cloudinary.com/mytotalhealth/image/upload/q_auto/web/app-store-badge.png" alt="Download on the App Store" id="app-store-badge" />
                        </a>
                    </p>
		        </div>
		    </header>
		)
	}
});

module.exports = Header;



// WEBPACK FOOTER //
// ./src/common/routes/components/header.jsx